import React from 'react';
import PropTypes from 'prop-types';

const CustomPagination = ({ current, total, pageSize, onChange }) => {
	const totalPages = Math.ceil(total / pageSize);

	// ✅ Corrected Logic to Show 10 Pages Properly
	const getPaginationRange = () => {
		const range = [];
		const maxVisiblePages = 10;

		let leftBound = Math.max(1, current - Math.floor(maxVisiblePages / 2));
		let rightBound = leftBound + maxVisiblePages - 1;

		// Ensure rightBound does not exceed totalPages
		if (rightBound > totalPages) {
			rightBound = totalPages;
			leftBound = Math.max(1, rightBound - maxVisiblePages + 1);
		}

		// Add first page and ellipsis if needed
		if (leftBound > 1) {
			range.push(1);
			if (leftBound > 2) {
				range.push('...');
			}
		}

		// Add visible pages dynamically
		for (let i = leftBound; i <= rightBound; i++) {
			range.push(i);
		}

		// Add last page and ellipsis if needed
		if (rightBound < totalPages) {
			if (rightBound < totalPages - 1) {
				range.push('...');
			}
			range.push(totalPages);
		}

		return range;
	};

	const paginationRange = getPaginationRange();

	// ✅ Updated Styles for Pagination
	const containerStyle = {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'space-between',
		width: '100%',
		padding: '10px 16px',
		
		background: '#f8f9fa',
		borderTop: '0.5px solid rgba(218, 218, 221, 1)',
		borderRadius: '0 0 8px 8px',
		overflow: 'hidden',
		marginTop: 'auto', // ✅ Moves the container to the bottom
		position: 'sticky', // ✅ Sticks it to the bottom
		bottom: 0, // ✅ Ensures it's at the very bottom
		zIndex: 10, // ✅ Ensures it stays above other content if needed
	};
	const buttonStyle = {
		padding: '6px 12px',
		fontSize: '12px',
		fontFamily: 'Inter, sans-serif',
		border: '1px solid #d9d9d9', // ✅ Always gray border for inactive
		borderRadius: '5px',
		background: '#FFFFFF', 
		cursor: 'pointer',
		color: '#666', // ✅ Inactive text color
		transition: 'all 0.2s ease-in-out',
		minWidth: '36px',
		textAlign: 'center',
		outline: 'none',
		boxShadow: 'none',
	};

	const activeButtonStyle = {
		...buttonStyle,
		backgroundColor: '#f0f0f0', // ✅ White background when active
		color: '#000', // ✅ Black text when active
		borderColor: '#1890ff', // ✅ Blue border when active
		fontWeight: 500, // Optional for bold text
	};

	


	const paginationContainerStyle = {
		display: 'flex',
		gap: '8px',
		justifyContent: 'center',
		width: '100%',
	};

	const buttonWrapperStyle = {
		display: 'flex',
		gap: '8px',
		alignItems: 'center',
		justifyContent: 'flex-end', 
		width: 'auto',
	};
	const prevNextButtonStyle = {
		padding: '8px 16px', // ✅ Increased padding for a better click area
		fontSize: '12px',
		fontFamily: 'Inter, sans-serif',
		border: '1px solid #d9d9d9', // ✅ Consistent border
		borderRadius: '5px',
		background: '#FFFFFF', // ✅ White background for inactive state
		cursor: 'pointer',
		color: '#666', // ✅ Inactive text color
		transition: 'all 0.2s ease-in-out',
		width: '80px', // ✅ Set width for Previous/Next buttons
		height: '36px', // ✅ Set height for Previous/Next buttons
		textAlign: 'center',
		lineHeight: '20px', // ✅ Center text vertically
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		outline: 'none', // ✅ Remove focus outline
		boxShadow: 'none', // ✅ Remove focus shadow
	};
	
	
	const disabledPrevNextButtonStyle = {
		...prevNextButtonStyle,
		cursor: 'not-allowed',
		color: '#ccc',
		borderColor: '#f0f0f0',
		background: '#FFFFFF',
		pointerEvents: 'none',
	};

	const separatorStyle = {
		height: '20px',
		borderLeft: '1px solid #d9d9d9',
		margin: '0 8px',
	};

	return (
		<div style={containerStyle}>
			{/* Pagination Numbers Centered */}
			<div style={paginationContainerStyle}>
				{paginationRange.map((page, index) => (

					<>
					{console.log(page, "page", current, "current", totalPages, "totalPages")}
					<button
						key={index}
						onClick={() => typeof page === 'number' && onChange(page)}
						style={
							page === current
								? activeButtonStyle
								: {
									...buttonStyle,
									backgroundColor: '#FFFFFF', // ✅ White background when active
									color: '#000', // ✅ Black text when active
									borderColor: '#D4D4D4', // ✅ Blue border when active}
								}
						}
						disabled={page === '...'}
					>
						{page}
					</button>
					</>
				))}
			</div>

			{/* Previous and Next Buttons with Separator (Right) */}
			<div style={buttonWrapperStyle}>
				<button
					onClick={() => onChange(current - 1)}
					disabled={current <= 1}
					style={current <= 1 ? disabledPrevNextButtonStyle : prevNextButtonStyle}
				>
					← Previous
				</button>

				<div style={separatorStyle} /> {/* ✅ Add Separator */}

				<button
					onClick={() => onChange(current + 1)}
					disabled={current >= totalPages}
					style={current >= totalPages ? disabledPrevNextButtonStyle : prevNextButtonStyle}
				>
					Next →
				</button>
			</div>
		</div>
	);
};

CustomPagination.propTypes = {
	current: PropTypes.number.isRequired,
	total: PropTypes.number.isRequired,
	pageSize: PropTypes.number.isRequired,
	onChange: PropTypes.func.isRequired,
};

export default CustomPagination;